import {
  CheckArgumentsTemplateListView,
  type CheckArgumentsTemplateListConfig,
} from "../check-arguments-templates-shared";

const config: CheckArgumentsTemplateListConfig = {
  listApiPath:
    "/api/internal/client-portal/check-arguments-templates/bankruptcy/",
  settingsPathPrefix: "bankruptcy-templates",
  pageTitle: (t) => t("Bankruptcy"),
  testIdPrefix: "bankruptcy-template",
  apiPathPrefix: "bankruptcy",
  filterBarTestId: "bankruptcy",
};

export const BankruptcyTemplateListView =
  CheckArgumentsTemplateListView(config);
